import { API } from '@/constant/constants'
import {
  DATA_PAGINATION,
  Location,
  SETUP_STATUS,
  SearchParams,
  Site,
  UPDATE_STATION_DATA,
} from '@/types'
import { Controller } from '@/types/controller'
import { queryStringify } from '@/ultils'
import axiosClient from '../axiosClient'

export const setupApi = {
  getOverAllStatus(interfaceId: number) {
    const url = API.CONFIG_SETUP.DEFAULT.replace(
      ':interfaceId',
      `${interfaceId}`,
    )
    return axiosClient.get<SETUP_STATUS>(url)
  },
  getCommonData(interfaceId: number) {
    const url = API.CONFIG_SETUP.COMMON_DATA.DEFAULT.replace(
      ':interfaceId',
      `${interfaceId}`,
    )
    return axiosClient.get<SETUP_STATUS>(url)
  },
  getDiscoverData(interfaceId: number) {
    const url = API.CONFIG_SETUP.DISCOVER_DATA.DEFAULT.replace(
      ':interfaceId',
      `${interfaceId}`,
    )
    return axiosClient.post<DATA_PAGINATION<Controller>>(url)
  },
  getSites(interfaceId: number, searchParams: SearchParams = {}) {
    const url = `${
      API.CONFIG_SETUP.SITE.DEFAULT
    }/${interfaceId}${queryStringify(searchParams)}`
    return axiosClient.get<DATA_PAGINATION<Site>>(url)
  },
  getLocations(siteId: number, searchParams: SearchParams = {}) {
    const url = `${API.CONFIG_SETUP.LOCATION.DEFAULT}/${siteId}${queryStringify(
      searchParams,
    )}`
    return axiosClient.get<DATA_PAGINATION<Location>>(url)
  },
  getControllers(interfaceId: number) {
    const url = `${API.CONFIG_SETUP.CONTROLLER.DEFAULT}/${interfaceId}`
    return axiosClient.get<DATA_PAGINATION<Controller>>(url, {
      params: { interfaceId: interfaceId, PageSize: 9999 },
    })
  },
  /**
   * Marks the controller's setup as finished — Pending Setup becomes Active.
   *
   * The last thing the wizard does, after the stations exist and have been
   * geotagged: until it is called the controller is still a setup in progress
   * and the app treats it as one.
   */
  completeSetup(interfaceId: number) {
    const url = `/api/setup/${interfaceId}/complete`
    return axiosClient.post<{ success?: boolean; message?: string }>(url)
  },
  updateStation(data: UPDATE_STATION_DATA[]) {
    const url = API.CONFIG_SETUP.STATION.UPDATE
    return axiosClient.put(url, data)
  },
}

export default setupApi
